module.exports = __webpack_public_path__ + "img/about_pic6.2fefec15.png";